import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';


// IMPORT GUARD FILES

import { AuthGuard } from './../../auth.guard';
import { ModuleGuard } from './../../permission.guard';
import { Role } from './../../_models/role';
import { Permission } from './../../_models/permission';

// IMPORT TIME-SHEET MODULE COMPONENTS
import { MainTimesheetComponent } from './main-timesheet.component';
import { TimeSheetComponent } from '../time-sheet.component';
import { WeekListComponent } from '../week-list/week-list.component';
import { SingleWeekComponent } from '../single-week/single-week.component';
import { UserSingleWeekComponent } from '../user-single-week/user-single-week.component';
import { AdminTimeSheetComponent } from '../admin-time-sheet/admin-time-sheet.component';
import { AdminReportAComponent } from '../admin-report-a/admin-report-a.component';
import { AdminReportBComponent } from '../admin-report-b/admin-report-b.component';



const routes: Routes = [

  {
    path: '',
    component: MainTimesheetComponent,
    children: [

      {
        path: 'time-sheet',
        component: TimeSheetComponent
      },
      {
        path: 'week-list',
        component: WeekListComponent
      },
      {
        path: 'single-week',
        component: SingleWeekComponent
      },
      {
        path: 'user-single-week',
        component: UserSingleWeekComponent
      },
      {
        path: 'admin-time-sheet',
        component: AdminTimeSheetComponent
      },
      {
        path: 'admin-report-a',
        component: AdminReportAComponent
      },
      {
        path: 'admin-report-b',
        component: AdminReportBComponent
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MainTimesheetRoutingModule { }
